import { IS_LOADING } from '@/store/types/root/actions-types';
import { SUB_CATEGORY_CREATE_REQUEST, SUB_CATEGORY_UPDATE_REQUEST, SUB_CATEGORY_DELETE_REQUEST, GET_SUB_CATEGORIES_REQUEST } from './action-types';
import {ADD_SUB_CATEGORY_TO_LIST, UPDATE_SUB_CATEGORY_IN_LIST, DELETE_SUB_CATEGORY_FROM_LIST, ADD_SUB_CATEGORIES_TO_LIST } from "./mutation-types"
import api from "@/api/api"

export default {

    [GET_SUB_CATEGORIES_REQUEST]: async ({ commit })=>{
        let response = {}
        try {
            response =   await api.get("/catalogs/categories/sub-categories")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_SUB_CATEGORIES_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false , { root: true })
        }
        return response
    },

    [SUB_CATEGORY_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        const categoryID = body.selectedCategoryID 
        let selectedCategory = body.categoriesList.filter(item => { return item.id == categoryID  });
        selectedCategory =  selectedCategory.length > 0 ? selectedCategory[0] : {}

        if(body.categoriesList)
            delete body.categoriesList

        if(body.selectedCategoryID)
            delete body.selectedCategoryID   
        
        if(body.default_points){
            body.points = body.default_points 
            delete body.default_points 
        }
        try {
            response =   await api.post(`/admin/catalogs/categories/${categoryID}/sub-categories/`, body)
            if(response.data.statusCode === 200){
                    const reponseBody = response.data.body
                    reponseBody.category = selectedCategory.name
                    reponseBody.parentCategory = {
                        default_points: selectedCategory.default_points,
                        id: selectedCategory.id,
                        name: selectedCategory.name
                    }
                    commit(ADD_SUB_CATEGORY_TO_LIST, reponseBody)
            }   
            return response         
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [SUB_CATEGORY_UPDATE_REQUEST]: async ({ state, commit }, body)=>{
        const lodash = require('lodash');
        const subCategoryID = body.id
        const categoryID = body.selectedCategoryID 
        let selectedCategory = body.categoriesList.filter(item => { return item.id == categoryID  });
        selectedCategory =  selectedCategory.length > 0 ? selectedCategory[0] : {}
        if(body.id)
            delete body.id
      
        if(body.categoriesList)
            delete body.categoriesList

        if(body.selectedCategoryID){
            body.category_id = categoryID
            delete body.selectedCategoryID 
        }
              
        if(body.default_points){
            body.points = body.default_points 
            delete body.default_points 
        }
        if(Object.keys(selectedCategory).length>0){
            body.category = selectedCategory.name
        }

        let response = {}
        let oldCategory = state.subCategoriesList.filter(item=>{ return item.id == subCategoryID})
        oldCategory = oldCategory.length > 0 ? oldCategory[0] : {}
        const bodyDifference = lodash.omitBy(body, (value, key) => oldCategory[key] === value);
        delete bodyDifference.category
        try{
            response =   await api.put("/admin/catalogs/categories/sub-categories/" + subCategoryID, bodyDifference)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "Subcategory Updated."){
                    
                    body.name = body.name
                    body.id = subCategoryID
                    delete body.category_id
                    commit(UPDATE_SUB_CATEGORY_IN_LIST, body)
                }
            }            
        } catch (err) {
            commit(IS_LOADING, false, { root: false })
        }
        return response
    },

    [SUB_CATEGORY_DELETE_REQUEST]: async ({ commit }, categoryIDs)=>{
        let response = {}
        try{
            response =   await api.post("/admin/catalogs/categories/sub-categories/delete", {"ids": categoryIDs})
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if(reponseBody.message === "Subcategory(s) Deleted." )
                    commit(DELETE_SUB_CATEGORY_FROM_LIST, categoryIDs)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    }
    

}
